<template>

    <tr class="capability">
        <td class="icon" width="15"><i class="fas fa-check text-primary"></i></td>
        <td class="d-none d-md-table-cell" width="25%"><div class="title" v-html="title"></div></td>
        <td class="desc d-none d-md-table-cell"><slot></slot></td>
        <td class="d-table-cell d-md-none"><div class="title mb-5">{{ title }}</div><slot></slot></td>
    </tr>

</template>

<style scoped lang="scss">

    tr.capability {
        border: none;
        padding: 0;
        td {
            @include font-medium(14px);
            border-bottom: 1px solid $color-rule;
            line-height: 1.6em;
            padding: 20px;
            text-align: left;
            vertical-align: top;
            &.icon {
                padding: 20px 0 20px 20px;
            }
            &.desc {
                border-left: 1px solid $color-rule-light;
            }
            .title {
                @include font-semibold(14px);
            }
        }
    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
            required: true,
        },
    },

}

</script>